/**
 * Quick actions strip — one-click shortcuts to the create flows and tools a
 * role uses most. Each action either links (`to`) or runs (`onClick`).
 * actions: [{ key, label, sub, icon, tone, to?, onClick? }]
 */
import { Link } from 'react-router-dom';
import { Icon } from './icons';
import './modern.css';

export default function QuickActions({ actions = [], title = 'Quick actions', sub = 'Shortcuts to everyday tasks.' }) {
  if (!actions.length) return null;
  return (
    <section className="md-panel md-qa md-rise" aria-label={title}>
      <div className="md-panel-head">
        <span className="md-icon" style={{ '--md-tone': '#f59e0b' }}>{Icon.bolt}</span>
        <div>
          <div className="md-panel-title">{title}</div>
          <div className="md-panel-sub">{sub}</div>
        </div>
      </div>
      <div className="md-qa-grid">
        {actions.map((a) => {
          const inner = (
            <>
              <span className="md-qa-icon" style={{ '--tone': a.tone }}>{a.icon}</span>
              <span className="md-qa-text">
                <b>{a.label}</b>
                {a.sub && <small>{a.sub}</small>}
              </span>
            </>
          );
          return a.to
            ? <Link key={a.key} to={a.to} className="md-qa-btn" style={{ '--tone': a.tone }}>{inner}</Link>
            : <button key={a.key} type="button" className="md-qa-btn" style={{ '--tone': a.tone }} onClick={a.onClick}>{inner}</button>;
        })}
      </div>
    </section>
  );
}
